import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const deleteAdminPurchaseOrder = createAsyncThunk(
    "/admin/delete-admin-po",
    async (id, { rejectWithValue }) => {
        try {
            const myurl = `${V_URL}/believe/delete-po/${id}`;

            const response = await axios({
                method: "delete",
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });

            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                toast.error(data.message || "Failed to delete Purchase Order");
                return rejectWithValue(data);
            }
        } catch (error) {
            const message = error.response?.data?.message || error.message || "Something went wrong";
            toast.error(message);
            return rejectWithValue(error.response?.data || message);
        }
    }
);

const deleteAdminPurchaseOrderSlice = createSlice({
    name: "deleteAdminPurchaseOrder",
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(deleteAdminPurchaseOrder.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteAdminPurchaseOrder.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(deleteAdminPurchaseOrder.rejected, (state, action) => {
                state.data = null;
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default deleteAdminPurchaseOrderSlice.reducer;
